import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import { Provider } from 'react-redux';
import store from './reduxStore/ConfigureStore';

function App() {
  const { user, loading } = useAuth();
  let Validado = user?.valido

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (Validado) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <Provider store={store}>
        <AuthProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <div className="halcoloader h-letras"></div>
              <App />
            </div>
          </NavigationProvider>
        </AuthProvider>
        </Provider>
    </Router>
  );
}
